import { useFormatter } from '@grandvisionhq/frk-routing';
import { useIntl } from '@grandvisionhq/state';
import { isDefined, getLocalizedValue, getProductKeyFromCTType } from '@grandvisionhq/utils';

const useFormatProductLinks = ({ products  })=>{
    const formatter = useFormatter();
    const { locale  } = useIntl();
    return products.filter(isDefined).map((product)=>{
        var _sku;
        const sku = (_sku = product.masterVariant.sku) !== null && _sku !== void 0 ? _sku : '';
        const slug = typeof product.slug === 'string' ? product.slug : getLocalizedValue(product.slug, locale);
        var ref;
        const key = getProductKeyFromCTType((ref = product === null || product === void 0 ? void 0 : product.productType) !== null && ref !== void 0 ? ref : '');
        const link = formatter({
            route: 'products.detail',
            params: {
                sku,
                slug,
                key
            }
        });
        return {
            link: typeof link === 'string' ? link : '#',
            sku
        };
    });
};

export { useFormatProductLinks };
//# sourceMappingURL=use-format-product-links.js.map
